import { Table, THead, TBody, TR, TH, TD } from '@/components/ui/Table';
import { Chip } from '@/components/ui/Chip';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { formatIDR, formatNumber, formatDateTime } from '@/lib/format';
import { Undo2 } from 'lucide-react';
import type { AppReturn, RefundMethod } from '@/types/domain';

const REFUND_VARIANT: Record<RefundMethod, 'default' | 'success' | 'info' | 'warning'> = {
  cash: 'success',
  qris: 'info',
  transfer: 'info',
  original: 'default',
};

export interface ReturnListProps {
  returns: AppReturn[];
  isLoading?: boolean;
  onView?: (ret: AppReturn) => void;
}

export function ReturnList({ returns, isLoading, onView }: ReturnListProps) {
  if (isLoading) {
    return <div className="py-16 text-center text-ink-subtle text-body">Loading returns…</div>;
  }
  if (returns.length === 0) {
    return (
      <EmptyState
        icon={<Undo2 size={24} strokeWidth={1.5} />}
        title="Belum ada return"
        description="Return/refund yang dibuat akan muncul di sini."
      />
    );
  }
  return (
    <Table>
      <THead>
        <TR>
          <TH>Tanggal</TH>
          <TH>Invoice</TH>
          <TH>Item</TH>
          <TH>Refund method</TH>
          <TH className="text-right">Refund</TH>
          {onView && <TH className="text-right">Aksi</TH>}
        </TR>
      </THead>
      <TBody>
        {returns.map((r) => (
          <TR key={r.id}>
            <TD className="whitespace-nowrap">{formatDateTime(r.createdAt)}</TD>
            <TD>
              <code className="text-caption font-mono text-ink">{r.invoiceNumber}</code>
            </TD>
            <TD>{formatNumber(r.items.length)} item</TD>
            <TD>
              <Chip variant={REFUND_VARIANT[r.refundMethod]}>{r.refundMethod}</Chip>
            </TD>
            <TD className="text-right font-medium tabular-nums">
              {formatIDR(r.refundAmount)}
            </TD>
            {onView && (
              <TD className="text-right">
                <Button variant="ghost" size="sm" onClick={() => onView(r)}>
                  Detail
                </Button>
              </TD>
            )}
          </TR>
        ))}
      </TBody>
    </Table>
  );
}
